import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { IS_DEV_ENV } from 'utils/env';

// Mark the browser tab (title + favicon) when running against a dev backend,
// so a dev tab is never mistaken for production at a glance.
if (IS_DEV_ENV) {
  document.title = '🚧 PadiHAT DEV';
  const icon = document.querySelector('link[rel="icon"]');
  if (icon) icon.href = `${process.env.PUBLIC_URL}/favicon-dev.png`;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
